import { BaseApi } from '@/main/baseApi';

import {
	DMS_MODULE,
	NAME,
} from './constants';

class ReverseJobOrderProvider extends BaseApi {
	async insertData(dto: any) {
		const result = await this.post(`/${DMS_MODULE}/${NAME}/Insert`, dto);
		return result;
	}

	async approveReturnRequest(dto: any) {
		const result = await this.post(`/${DMS_MODULE}/${NAME}/ApproveReject`, dto);

		return result;
	}

	async getWorkflowApprovalConfig(approvaltype: string, approvallevel: string) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/GetWorkflowApprovalConfig?approvaltype=${approvaltype}&approvallevel=${approvallevel}`);
		return result;
	}

	async isReverseJobOrderExists(invoiceid: any) {
		const result = await this.fetch(`/${DMS_MODULE}/${NAME}/IsReverseJobOrderExists?invoiceid=${invoiceid}`);
		return result;
	}
}

export const apiProvider = new ReverseJobOrderProvider(DMS_MODULE, NAME);
